import { z } from 'zod';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';
import { StudyGroup } from '@prisma/client';

export const studyGroupZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(StudyGroup)))
    .transform(
      (value) => StudyGroup[value as keyof typeof StudyGroup] as StudyGroup,
    );
